module.exports = {
    CS_REP_ACCESS_URL: "https://permissions.amazon.com/group.mhtml?target=21895708",
    EFPM_ACCESS_URL: "https://permissions.amazon.com/group.mhtml?target=21895700"
};
